import { useCallback, useEffect, useState } from "react";
import { BasicTable, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { SelectProject } from "../../../erp/cellEditor/BudgetAccountantOperation/SelectProject";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { DropDown } from "../../../theme/Component/DropDown";
import { ListMenu } from "../../../theme/Component/ListMenu";

interface Props{
    contract:any;
    updateContract:any;
}
export const ContractProject=({contract,updateContract}:Props)=>{

    const [list,setList] = useState<any>([]);
    const [bean,setBean] = useState<any>({});
    const [project,setProject] = useState<any>({});

    useEffect(()=>{
       getlista();
        
    },[])
    useEffect(()=>{
       if(updateContract)
            updateContract(JSON.stringify(list));
        
    },[list])


    const getlista = useCallback(()=>{
        if(contract.ProjectList)
        {
            setList(JSON.parse(contract.ProjectList));
        }else{
            setList([]);
        }
    },[contract])

    const add = ()=>{
        console.log(project);
        let tmep:any = [...list];
        tmep.push(
            {DataBeanProperties:project}
        )
        setList(tmep)
        setProject({});
        
    }
    const del = ()=>{
        let tmp = list.filter(item => item.DataBeanProperties.IDProject!= bean.IDProject);
        setList(tmp);
    }
     const listaBotones =()=>{
        const botones = [
            {titulo:'Eliminar',icono:'ri-delete-bin-line',visible:true,evento:()=>{del()}},
        ]
        return(
            <ListMenu listaBotones={botones}/>
        )
    }

    
      const head = [
        {title:'ID',property:'IDProject',visible:true,mask:MASK_NUMBER},
        {title:'Nombre',property:'Name',visible:true},
        {title:'Descripcion',property:'Description',visible:true}        
    ]

    return(
        <div className="row">
            <div className="col-md-6">
                <SelectProject idSelector={project.IDProject} returnType="Object" onChange={(e)=>{setProject(e)}}/>
            </div>
            <div className="col-md-6 mt-4">
                <BasicButton disable={!project.IDProject} icon="" eventClick={add}>Agregar</BasicButton>
            </div>
            <div className="col-md-12">
                <BasicTable listButtons={listaBotones()} head={head} body={list} rowSet={setBean}></BasicTable>
            </div>
        </div>
    )
}